import React from 'react';
import moment from 'moment';
import { Typography, Spin } from 'antd';
import InfoCard from '../../common/InfoCard/InfoCard';
import DottedBorderBackground from '../../common/DottedBorderBackground/DottedBorderBackground';
import { CardChangeButton } from '../../../../../components/Card';
import { convertPenniesToRub } from '../../../../../helpers/convertPenniesToRub';
import styles from './BalanceCard.module.scss';

const { Paragraph } = Typography;

const BalanceCard = ({
  title,
  className,
  loading = false,
  dark = true,
  balance,
  onChangeButtonClick,
}) => {
  return (
    <InfoCard
      title={title}
      action={
        <CardChangeButton onClick={onChangeButtonClick} disabled={loading} />
      }
      dark={dark}
      className={className}
    >
      <Spin spinning={loading}>
        <DottedBorderBackground>
          <Typography className={styles.typography}>
            <Paragraph className={styles.date}>{`На ${moment().format(
              'DD.MM.YYYY'
            )} г.`}</Paragraph>
            <Paragraph className={styles.sum}>
              {typeof balance === 'number'
                ? `${convertPenniesToRub(balance)} руб.`
                : ''}
            </Paragraph>
          </Typography>
        </DottedBorderBackground>
      </Spin>
    </InfoCard>
  );
};

export default BalanceCard;
